import './InfoEditor.less';
import React, {useContext} from 'react';
import __ from "../../../i18n";
import CustomForm from "../../../../bootstrap/components/custom-form/CustomForm";
import AuthContext from "../../../contexts/auth/AuthContext";
import NoticeBox, {NOTICE_INFO} from "../../../../bootstrap/components/notice-box/NoticeBox";
import {TOOLBAR_MODE_BASIC} from "../../../widgets/rich-text-input/RichTextInput";


export default function InfoEditor({notice, layoutConfig, requestUpdate, onDone, onCancel}) {

    const {user, patchInfo} = useContext(AuthContext);

    const fieldsConfig = {
        full_name: {
            name: __('Full name'),
            type: 'text',
            rules: {
                required: true,
                minLength: 3
            },
            options: {
                appearance: 'box',
                prompt: __('Enter your full name')
            }
        },
        title: {
            name: __('Title'),
            type: 'text',
            options: {
                appearance: 'box',
                prompt: __('Your current position')
            }
        },
        email: {
            name: __('Email'),
            type: 'text',
            rules: {
                required: true,
                match: 'email'
            },
            options: {
                appearance: 'box',
                prompt: __('email@example.com')
            }
        },
        phone: {
            name: __('Phone number'),
            type: 'text',
            rules: {
                required: true,
                match: 'vietnamese_phone'
            },
            options: {
                appearance: 'box',
                prompt: __('Your mobile phone number')
            }
        },
        password: {
            type: 'text',
            name: __('Current password'),
            defaultValue: '',
            rules: {
                required: true
            },
            options: {
                style: 'password',
                passwordCanShow: true,
                appearance: 'box',
                placeholder: __('Enter your current password to verify')
            }
        },
        new_password: {
            name: __('New password'),
            type: 'text',
            defaultValue: '',
            rules: {
                required: true,
                minLength: {
                    value: 6,
                    error: __('Password must contain at least ::minLength characters', {minLength: 6})
                }
            },
            options: {
                style: 'password',
                passwordCanShow: true,
                appearance: 'box',
                prompt: __('Enter new password'),
            }
        },
        introduction: {
            name: __('Introduction'),
            type: 'richText',
            options: {
                toolbarMode: TOOLBAR_MODE_BASIC,
            }
        }
    };

    return <div className="info-editor">
        {
            notice &&
            <NoticeBox
                type={NOTICE_INFO}
                message={notice}
            />
        }
        <CustomForm
            fieldsConfig={fieldsConfig}
            layoutConfig={layoutConfig}
            submitChanges={(values, onSuccess, onError) => {
                requestUpdate(values, () => {
                    patchInfo({user: {...user, ...values}});
                    onDone();
                }, (errorMessage) => {
                    onError(errorMessage);
                });
            }}
            cancel={() => {
                onCancel();
            }}
            defaultValues={user}
            submitText={__('Save changes')}
        />
    </div>;
}
